import { FormEvent, useEffect, useState } from "react"
import {
  Form,
  useAppNotificationStore,
  UploadRecordCredentials,
  useAuthStore,
  PictureUploadInterface,
  useProfileStore,
  ProfileInterface,
  useApplicationStore,
  stages,
} from "stores"
import { Button, ChooseFile, H4, P1 } from "components"
import { useNavigate } from "react-router-dom"
import { BASEURL } from "utils"

export const PictureUpload: React.FC<{}> = () => {
  const { setDashboardContext } = useAppNotificationStore()
  const navigate = useNavigate()
  const { toast } = useAppNotificationStore()
  const [form] = useState(new Form<PictureUploadInterface>())
  const { updateStage } = useApplicationStore()
  const [uploadForm] = useState(new Form<UploadRecordCredentials>())
  const { updateProfilePicture, profile } = useProfileStore()

  useEffect(() => {
    setDashboardContext("Picture Upload")
    uploadForm.setCredential("documentType", "ProfilePicture")
  }, [setDashboardContext, uploadForm])

  const handleFileUpload = async (e: FormEvent) => {
    e.preventDefault()

    const formData = new FormData()

    const inputFile = document.getElementById("file")! as any
    formData.append("documentType", uploadForm.credentials.documentType)
    formData.append("file", inputFile.files[0])

    return await fetch(`${BASEURL}/api/Utility/upload`, {
      method: "post",
      body: formData,
      headers: { ...useAuthStore.getState().getAuthHeader() },
    }).then((resp) => resp.json())
  }

  const handleProfileUpload = async (e: FormEvent) => {
    e.preventDefault()
    form.submitting(true)

    try {
      handleFileUpload(e).then(async (resp) => {
        form.submitting(false)
        if (resp.isSuccessful === true) {
          await updateProfilePicture({
            profilePicture: resp.data.fullPath,
          }).then((resp) => {
            if (resp.isSuccessful === true) {
              toast.success(resp.message)
              navigate("/dashboard/registration/complete-profile")
            } else {
              toast.error(resp.message)
            }
          })
        }
      })
    } catch (error: any) {
      form.submitting(false)
      console.log(error)
      toast.error(error?.message as string)
    }
  }

  const handleNext = async () => {
    await updateStage({ currentStage: profile?.nextStage! }).then((resp) => {
      if (resp.isSuccessful === true) {
        useProfileStore.setState({
          profile: { ...profile!, nextStage: stages.SubmitApplication },
        })
        navigate("/dashboard/registration/complete-profile")
      }
    })
  }

  return (
    <div className="flex flex-col gap-12 items-center">
      <div className="flex flex-col items-center gap-6">
        <H4 className="font-semibold text-accentText">Picture Upload</H4>
        <P1 className="text-accentGrey1 text-center">
          Select your profile picture
        </P1>
      </div>
      <form
        onSubmit={handleProfileUpload}
        className="w-full lg:w-[536px] flex flex-col gap-8"
      >
        <div className="gap-5 w-full flex flex-col items-end">
          {/* <Label aria-required>Please select your profile picture</Label> */}
          <ChooseFile />
          <Button
            type="submit"
            title="Upload"
            color="primary"
            className="w-52"
            disabled={form.isSubmitting}
            submitting={form.isSubmitting ? "true" : "false"}
          >
            Upload
          </Button>
        </div>

        <div className="flex gap-4 justify-end items-center mt-2">
          <Button
            type="button"
            title="Previous"
            color="secondary"
            className="w-52"
            onClick={() => navigate("/dashboard/registration/records")}
          >
            Previous
          </Button>
          <Button
            type="button"
            title="Next"
            color="primary"
            className="w-52"
            onClick={() => handleNext()}
          >
            Next
          </Button>
        </div>
      </form>
    </div>
  )
}
